import React, { Component } from 'react';
import moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { connect } from 'react-redux';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import DrawerDropDownMenu from './Components/DrawerDropDownMenu';
import { formInput, clearFormInput } from 'actions/FormActions';
import "./styles/ItemDetailDrawer.css"
import TransferProductDialog from '../transferProduct/TransferProductDialog';
import Pagination from 'screens/components/basic/Pagination';
import { GetProductInventoryLog, getProductsGroupedFromWarehouse, setRestockQty } from 'actions/EntityActions';
import Button from 'screens/components/basic/Button';
import { showSnackbar } from 'actions/CommonActions';
import { getCsvReport } from 'actions/ReportsAction';
import { Drawer } from '@mui/material';

class ItemDetailDrawer extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      fromDate: "",
      toDate: "",
      reason: "",
      transferDialogOpen: false,
      activePage: 1,
      itemsPerPage: 20,
      restockCap: 0
    }
    this.onChange = this.onChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this)
    this.getProductsGrouped = this.getProductsGrouped.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.refreshWarehouses === null && this.props.refreshWarehouses !== null) ||
      (prevProps.refreshInventoryAdjust === null && this.props.refreshInventoryAdjust !== null) ||
      (prevProps.refreshWarehouses !== null && prevProps.refreshWarehouses !== this.props.refreshWarehouses) ||
      (prevProps.refreshInventoryAdjust !== null && prevProps.refreshInventoryAdjust !== this.props.refreshInventoryAdjust)
    ) {
      this.fetchItemsNextPage()
    }
  }

  pageChange = (page) => {
    this.setState(prev => ({
      ...prev,
      activePage: page
    }), () => {
      this.fetchItemsNextPage();
    });
  }

  fetchItemsNextPage = () => {
    const model = {
      ProductId: this.props.clickedProduct,
      BranchId: this.props.clickedBranch,
      StartDate: this.props.fromDate,
      EndDate: this.props.toDate,
      Reason: this.props.reason,
      ItemsPerPage: this.state.itemsPerPage,
      PageNumber: this.state.activePage
    };
    this.props.GetProductInventoryLog(model);
  }

  onChange(e) {
    const { name, value } = e.target;
    const valueNum = parseInt(value)
    if (name === "restockCap" && valueNum < 0) {
      this.props.showSnackbar("Please enter a value greater than 0")
    } else {
      this.setState({ [name]: value });
      this.props.formInput(value, name);
    }
  }

  handleDateChange(e, isStartDate = true) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
    this.props.formInput(
      value,
      isStartDate ? "fromDate" : "toDate"
    );
  }

  formatXAxis = (tickItem) => {
    if (moment(tickItem).isValid()) {
      return moment(tickItem).format("YYYY-MM-DD");
    } else {
      return "NO DATA";
    }
  };

  formatTableCell = (date) => {
    if (moment(date).isValid()) {
      return moment(date).format("YYYY-MM-DD");
    } else {
      return "NO DATA";
    }
  };

  openTransferDialog = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        transferDialogOpen: !prevState.transferDialogOpen
      }
    });
  }

  closeDialogTransfer = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        transferDialogOpen: false
      }
    });
  }

  getProductsGrouped() {
    const model = {
      page: 1,
      itemsPerPage: 20,
      warehouseId: null,
      productName: !this.props.product ? "" : this.props.product.clickedProduct.productName,
      productSKU: !this.props.product ? "" : this.props.product.clickedProduct.sku,
      categoryId: "",
      quantity: "",
      orderBy: "DESC",
      sortBy: "",
      branchId: this.props.clickedBranch,
      productId: this.props.clickedProduct,
      productBrand: "",
      productSpecies: 0,
      onHold: ""
    }
    this.props.getProductsGrouped(model);
  }

  convertToWords = (str) => {
    if (str && str !== "") {
      return str.replace(/([A-Z])/g, ' $1').trim();
    }
  }

  handleSetRestockQty = () => {
    const model = {
      ProductId: this.props.clickedProduct,
      ReStockCap: this.state.restockCap
    }
    this.props.setRestockQty(model)
    this.setState({ restockCap: 0 })
  }

  download = () => {
    let productId = this.props.clickedProduct;
    let branchId = this.props.clickedBranch;
    let startDate = this.props.fromDate;
    let endDate = this.props.toDate;
    let reason = this.props.reason;

    this.props.getCsvReport(`warehouses/productInventoryLogDownload?productId=${productId}&branchId=${branchId}&startDate=${startDate}&endDate=${endDate}&reason=${reason}`, `productInventoryLog${productId}`);
  }

  render() {
    const p = this.props;
    const { clickedProduct, clickedBranchName } = p.product;
    const { imageURL, productName, id, sku } = clickedProduct;
    return (
      <section>
        <TransferProductDialog name="transferProductDialog" onClose={this.closeDialogTransfer} fromMIM={true} />
        <Drawer anchor="right" openSecondary={true} docked={false} width={800} open={p.open} onClose={this.props.close} onRequestChange={p.onRequestChange}>
          <div>
            <h3 className="inventory-header">Inventory - {clickedBranchName}</h3>
            <hr className="separator" />
            <div className="drawer-container">
              {/* Product info Section ------------------------------------------------------------------------------*/}
              {p.productInfo ?
                <section className="product-info">
                  <div><img src={!p.product ? null : imageURL} className="drawer-product-img" /></div>
                  <div className="product-details">
                    <div><span className="bold-highlight">{!p.product ? null : productName}</span></div>
                    <div className="product-info-line"><span><span className="subtitle-highlight">Product Id:</span><span className="product-info-value-id">{p.product ? id : null}</span></span></div>
                    <div className="product-info-line"><span><span className="subtitle-highlight">SKU:</span><span className="product-info-value-sku"> {!p.product ? null : sku}</span></span></div>
                    <div className="product-info-line"><span><span className="subtitle-highlight">UPC:</span><span className="product-info-value-upc"> {p.productInfo ? p.productInfo.upc : null}</span></span></div>
                    <div className="product-info-line"><span><span className="subtitle-highlight">Price:</span><span className="product-info-value-price"> ${p.productInfo ? p.productInfo.price : null}</span></span></div>
                  </div>
                </section>
                : null}
              {/* Quantity and restock Section --------------------------------------------------------------------- */}
              <section className="quantity-container">
                <div className="grid-container">
                  {/* row1 column1 */}
                  <div className="box">
                    <div className="info-column">
                      <span className="row-headers">Quantity</span>
                      <Button id="buttonTransfer" type="IconTransferButton" className="mb-3 trans_btns btnNewBrandPOS" onTouchTap={this.getProductsGrouped} />
                    </div>
                  </div>
                  {/* row1 column2 */}
                  <div className="box">
                    <div className="info-column">
                      <span className="glyphicon glyphicon-tags green-text icon-align">
                        <span className="quantities-header-icon">Store</span>
                      </span>
                      <span className="quantity-numbers">
                        {!p.singleStoreInventoryData ? null : p.singleStoreInventoryData.storeQty}
                      </span>
                      <span className="units-text">Unit(s)</span>
                    </div>
                  </div>
                  {/* row1 column3 */}
                  <div className="box">
                    <div className="info-column">
                      <span className="glyphicon glyphicon-home blue-text icon-align">
                        <span className="quantities-header-icon">Storage</span>
                      </span>
                      <span className="quantity-numbers">
                        {!p.singleStoreInventoryData ? null : p.singleStoreInventoryData.storageQty}
                      </span>
                      <span className="units-text">Unit(s)</span>
                    </div>
                  </div>
                  {/* row1 column4 */}
                  <div className="box">
                    <div className="info-column">
                      <span className="glyphicon glyphicon-remove danger icon-align">
                        <span className="quantities-header-icon">Damage</span>
                      </span>
                      <span className="quantity-numbers">
                        {!p.singleStoreInventoryData ? null : p.singleStoreInventoryData.damageQty}
                      </span>
                      <span className="units-text">Unit(s)</span>
                    </div>
                  </div>
                  {/* row2 column1 */}
                  <div className="box">
                    <div className="info-column">
                      <span className="row-headers">Low Stock Warn</span>
                      <Button
                        className="btnNewBrandPOS"
                        type="RaisedButton"
                        id="buttonSetRestoclQty"
                        label="Set"
                        onTouchTap={this.handleSetRestockQty}
                      />
                    </div>
                  </div>
                  {/* row2 column2 */}
                  <div className="box">
                    <div className="info-column">
                      <span className="lowstockwarn-header-new">Set New Cap</span>
                      <input className="input-field"
                        name="restockCap"
                        type="number"
                        id="inputNewCap"
                        min="0"
                        value={this.state.restockCap}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                  {/* row2 column3 */}
                  <div className="box">
                    <div className="info-column">
                      <span className="lowstockwarn-header-cap">Current Cap</span>
                      <span className="quantity-numbers">{!p.singleStoreInventoryData ? null : p.singleStoreInventoryData.reStockCap}</span>
                    </div>
                  </div>
                </div>
              </section>
              {/* Graph Chart Section ----------------------------------------------------------------------------- */}
              <section style={{ width: '100%' }}>
                <h3 className="Chart-header">Inventory Movement History</h3>
                <ResponsiveContainer width="100%" height={150}>
                  <AreaChart
                    width={500}
                    height={150}
                    data={p.productInventoryByDate}
                    syncId="anyId"
                    margin={{
                      top: 10,
                      right: 30,
                      left: 0,
                      bottom: 0
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="formattedModifiedDate" tickFormatter={this.formatXAxis} style={{ fontFamily: "Open Sans" }} />
                    <YAxis style={{ fontFamily: "Open Sans" }} />
                    <Tooltip />
                    <Area type="monotone" dataKey="previousQuantity" name="Prev Quantity" stroke="#FFA07A" fill="#FFA07A" tickFormatter={this.formatXAxis} />
                    <Legend />
                  </AreaChart>
                </ResponsiveContainer>

                <ResponsiveContainer width="100%" height={150} style={{ marginBottom: '30px' }}>
                  <AreaChart
                    width={500}
                    height={150}
                    data={p.productInventoryByDate}
                    syncId="anyId"
                    margin={{
                      top: 10,
                      right: 30,
                      left: 0,
                      bottom: 0
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="formattedModifiedDate" tickFormatter={this.formatXAxis} style={{ fontFamily: "Open Sans" }} />
                    <YAxis style={{ fontFamily: "Open Sans" }} />
                    <Tooltip />
                    <Area type="monotone" dataKey="newQuantity" name="New Quantity" stroke="#82ca9d" fill="#82ca9d" />
                    <Legend />
                  </AreaChart>
                </ResponsiveContainer>
              </section>
              <DrawerDropDownMenu
                onChange={this.onChange}
                handleDateChange={this.handleDateChange}
                download={this.download}
              />
              {/* Table for product inventory detail -------------------------------------------------------------- */}
              {p.productInventoryByDate &&
                <section className="quantity-container">
                  <div>
                    {
                      p.pageLength > 0 ?
                        <div className="multistore-pagination text-center mb-2">
                            <Pagination
                                length={p.pageLength}
                                itemsPerPage={this.props.itemsPerPage || 20}
                                activePage={this.state.activePage}
                                onPageChange={this.pageChange}
                                className={'pagination'}
                            />
                        </div>
                        : null
                    }
                  </div>
                  <Table bodyStyle={{ overflow: 'visible' }} className="full-width-table">
                    <TableHead displaySelectAll={false} adjustForCheckbox={false}>
                      <TableRow>
                        <TableCell key={'header-employeeName'} className="table-header-column" style={{ width: "150px" }}>Employee Name</TableCell>
                        <TableCell key={'header-modifiedDate'} className="table-header-column" style={{ width: "110px" }}>Modified Date</TableCell>
                        <TableCell key={'header-newQuantity'} style={{ width: "90px" }} className="table-header-column">New Quantity</TableCell>
                        <TableCell key={'header-quantityToChange'} style={{ width: "90px" }} className="table-header-column">Quantity to Change</TableCell>
                        <TableCell key={'header-previousQuantity'} style={{ width: "90px" }} className="table-header-column">Previous Quantity</TableCell>
                        <TableCell key={'header-reason'} className="table-header-column">Reason</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody displayRowCheckbox={false}>
                      {p.productInventoryByDate.map((product, i) => (
                        <TableRow key={i} >
                          <TableCell className="table-row-column" style={{ width: "150px" }}>{product.employeeName}</TableCell>
                          <TableCell className="table-row-column" style={{ width: "125px" }}>{this.formatTableCell(product.modifiedDate)}</TableCell>
                          <TableCell className="table-row-column" style={{ width: "90px" }}>{product.newQuantity}</TableCell>
                          <TableCell className={`table-row-column ${product.newQuantity - product.previousQuantity > 0 ? "green-text" : product.newQuantity - product.previousQuantity < 0 ? "red-text" : ""}`} style={{ fontWeight: "900", width: "90px" }}>{product.newQuantity - product.previousQuantity}</TableCell>
                          <TableCell className="table-row-column" style={{ width: "90px" }} >{product.previousQuantity}</TableCell>
                          <TableCell className="table-row-column" style={{ whiteSpace: "normal" }}>{this.convertToWords(product.reason)}</TableCell>
                        </TableRow>))}
                    </TableBody>
                  </Table>
                </section>
              }
            </div>
          </div>
        </Drawer>
      </section>
    )
  }

} const mapStateToProps = state => {

  return {
    pageLength: state.entity.productInventoryByBranchAndDate ? state.entity.productInventoryByBranchAndDate.total : 0,
    productInfo: state.entity.productInventoryByBranchAndDate ? state.entity.productInventoryByBranchAndDate.items[0] : [],
    reason: state.form.reason ? state.form.reason : null,
    fromDate: state.form.fromDate ? state.form.fromDate : "",
    toDate: state.form.toDate ? state.form.toDate : "",
    clickedProduct: state.form.clickedProduct,
    clickedBranch: state.form.clickedBranch,
    refreshWarehouses: state.entity.refreshWarehouses ? state.entity.refreshWarehouses : null,
    refreshInventoryAdjust: state.entity.refreshInventoryAdjust ? state.entity.refreshInventoryAdjust : null,
    singleStoreInventoryData: state.entity.singleStoreInventoryData ? state.entity.singleStoreInventoryData[0] : null
  };
};

const mapDispatchToProps = dispatch => {
  return {
    formInput: (value, name) => dispatch(formInput(value, name)),
    GetProductInventoryLog: model => dispatch(GetProductInventoryLog(model)),
    getProductsGrouped: (model) => dispatch(getProductsGroupedFromWarehouse(model)),
    setRestockQty: (model) => dispatch(setRestockQty(model)),
    showSnackbar: (msg) => dispatch(showSnackbar(msg)),
    getCsvReport: (url, name) => dispatch(getCsvReport(url, name)),
    clearFormInput: (name) => dispatch(clearFormInput(name))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemDetailDrawer)
